import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Col, Row, Table, Spinner, Alert } from 'react-bootstrap';
import { format } from 'date-fns';
import { BASE_URL } from "../../../../services/Api";
import { authHeader } from "../../../../services/auth-header";

function ViewPumpInternationalSalesEnquiry() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState({
        enquiryno: '',
        enquirydate: '',
        status: '',
        customer: null,
        contactperson: '',
        contactno: '',
        email: '',
        customerMultipleAddress: null,
        customermaterialcode: '',
        currency: '',
        enquiryItems: []
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}enquiry/findById/${id}`, {
                    headers: authHeader()
                });

                const enquiry = response.data;
                const firstItemCurrency = enquiry.enquiryItems?.[0]?.currency || '';

                setData({
                    enquiryno: enquiry.enquiryno,
                    enquirydate: enquiry.enquirydate,
                    status: enquiry.status,
                    customer: {
                        value: enquiry.customer?.id,
                        label: enquiry.customer?.companyname
                    },
                    contactperson: enquiry.contactperson,
                    contactno: enquiry.contactno,
                    email: enquiry.email,
                    customerMultipleAddress: enquiry.customeraddress ? {
                        value: enquiry.customeraddress.id,
                        label: enquiry.customeraddress.customeraddress
                    } : null,
                    customermaterialcode: enquiry.customermaterialcode,
                    currency: firstItemCurrency,
                    enquiryItems: enquiry.enquiryItems?.map(item => ({
                        ...item,
                        description: item.product?.description,
                        partno: item.product?.partno,
                        serialnumber: item.product?.serialnumber,
                        modelnumber: item.product?.modelnumber,
                        tagnumber: item.product?.tagnumber,
                        moc: item.product?.moc,
                        hsnsacno: item.hsnsacno || item.product?.hsnsacno,
                        itemcode: item.itemcode || item.product?.itemcode,
                        uom: item.uom || item.product?.unitofmeasurement
                    })) || []
                });
            } catch (err) {
                setError('Failed to fetch enquiry details. Please try again.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const currencyOptions = [
        { value: "", label: "Select Currency" },
        { value: "$ (USD)", label: "USD" },
        { value: "€ (EUR)", label: "EUR" },
        { value: "¥ (JPY)", label: "JPY" },
        { value: "£ (GBP)", label: "GBP" },
        { value: "₹ (INR)", label: "INR" },


    ];

    if (loading) {
        return (
            <div className="container text-center py-5">
                <Spinner animation="border" />
                <p>Loading enquiry details...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container py-5">
                <Alert variant="danger">{error}</Alert>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <div className="mb-4">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <p className="mb-0 me-4">
                        <strong>Enquiry No:</strong> {data.enquiryno}
                    </p>
                    <p className="mb-0 me-4">
                        {/* <strong>Date:</strong> {format(new Date(data.enquirydate), 'dd/MM/yyyy')} */}
                    </p>
                    <p className="mb-0">
                        <strong>Status:</strong> <span className={`badge bg-${data.status === 'Active' ? 'success' : 'secondary'}`}>
                            {data.status}
                        </span>
                    </p>
                </div>

                <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">Customer Details</h5>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Col md={6}>
                                <p><strong>Customer Name:</strong> {data.customer?.label}</p>
                            </Col>
                            <Col md={6}>
                                <p><strong>Contact Person:</strong> {data.contactperson}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <p><strong>Contact Number:</strong> {data.contactno}</p>
                            </Col>
                            <Col md={6}>
                                <p><strong>Email:</strong> {data.email}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <p><strong>Customer Address:</strong> {data.customerMultipleAddress?.label}</p>
                            </Col>
                            <Col md={6}>
                                <p><strong>Customer Material Code:</strong> {data.customermaterialcode}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <p><strong>Currency:</strong> {data.currency}</p>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h5 className="mb-0">Enquiry Items</h5>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead className="table-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Product Description</th>
                                        <th>Serial No.</th>
                                        <th>Model No.</th>
                                        <th>Tag No.</th>
                                        <th>Part No.</th>
                                        <th>MOC</th>
                                        <th>HSN Code</th>
                                        <th>Product Code</th>
                                        <th>Quantity</th>
                                        <th>UOM</th>
                                        <th>Currency</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.enquiryItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.description}</td>
                                            <td>{item.serialnumber || '-'}</td>
                                            <td>{item.modelnumber || '-'}</td>
                                            <td>{item.tagnumber || '-'}</td>
                                            <td>{item.partno || '-'}</td>
                                            <td>{item.moc || '-'}</td>
                                            <td>{item.hsnsacno || '-'}</td>
                                            <td>{item.itemcode || '-'}</td>
                                            <td>{item.quantity}</td>
                                            <td>{item.uom || '-'}</td>
                                            <td>{item.currency || data.currency}</td>
                                            <td className="text-muted small">{item.productremarks || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewPumpInternationalSalesEnquiry;
